S.swiper = {
    config: {
        // BUG preview bei loop
        loop: false,
        speed: 600,
        language: 'de',
    },

    elements: {
        $swiperContainer: null,
    },

    // var {jQuery} $swiper
    $swiper: null,

    init()
    {
        this.initSwiper();
    },

    // initSwiper
    initSwiper()
    {
        // get area-label Text Arrows (prevSlideMessage/nextSlideMessage)
        const slideMessageArray = S.swiperset.getSlideMessage(this.config.language);

        // https://swiperjs.com/swiper-api
        // this.$swiper = new Swiper(this.elements.$swiperContainer, {
        this.$swiper = new Swiper(this.elements.$swiperContainer.get(0), {
            // pass modules here
            // modules: [Navigation, Pagination],
            slidesPerView: 1,
            slidesPerGroup: 1,
            // spaceBetween: 30,
            speed: this.config.speed,
            centeredSlides: false,
            loop: this.config.loop,
            autoHeight: true,
            // https://swiperjs.com/swiper-api#param-preventClicks
            // https://swiperjs.com/swiper-api#param-preventClicksPropagation
            // wenn Bild nicht verlinkt auf false setzen
            // Barrierefreiheit sonst Image im Screenreader verlinkt
            preventClicks: false,
            preventClicksPropagation: false,
            // 7.0.0 +
            // Enable this feature to calculate each slides progress and visibility (slides in viewport will have additional visible class)
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,

            // autoplay: {
            //     delay: 3000,
            // },

            keyboard: {
                enabled: true,
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    // spaceBetween: 40,
                },
                1200: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    // spaceBetween: 50,
                },
            },

            // pagination optional
            // pagination: {
            //     el: this.$module.find('.swiper-pagination').get(0),
            //     clickable: true,
            //     type: 'fraction',
            // },

            navigation: {
                nextEl: this.$module.find('.swiper-button-next').get(0),
                prevEl: this.$module.find('.swiper-button-prev').get(0),
            },

            a11y: {
                prevSlideMessage: slideMessageArray['prev'],
                nextSlideMessage: slideMessageArray['next'],
            },

            on: {
                init: () =>
                {
                    // remove double iDs
                    S.swiperset.removeDuplicateId();
                },

                slideChange: () =>
                {
                    // stop video/audio
                    // S.swiperset.resetsrc(this.$module);
                },
            },
        });
    },
};
